module.exports = __webpack_public_path__ + "static/img/Samuela_Fainu.432ba39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Samuela_Fainu.jpg
// module id = 3bpu
// module chunks = 0